<app-side-menu [(isExpanded)]="isMenuExpanded">
	<app-side-menu-title> <span class="mat-title-medium">{{"Benachrichtigungen" | translate :
			"label-notifications"}}</span> </app-side-menu-title>
	<app-side-menu-header>
		<section class="notification-menu__processes-operator">
			<button mat-button class="notification-menu__mark-processes-seen"
				(click)="markAllProcessNotificationsSeen()" [disabled]="isMarkAllSeenDisabled()">
				{{"Alle als gelesen markieren" | translate: "label-mark-all-processes-seen"}}
			</button>
		</section>
	</app-side-menu-header>
	<app-side-menu-content>
		@if(processNotifications().length > 0 ){
		<cdk-virtual-scroll-viewport itemSize="150" minBufferPx="400" maxBufferPx="500">
			<app-process-notification (pauseClick)="pauseProcess($event.id)" (restartClick)="restartProcess($event.id)"
				(deleteClick)="deleteProcessNotification($event.id)" (downloadClick)="downloadProcess($event)"
				(isSeenChange)="setProgressNotificationSeen($event)"
				*cdkVirtualFor="let notification of processNotifications(); trackBy: identifyProcess"
				[processNotification]="notification" />
		</cdk-virtual-scroll-viewport>
		} @else {
		<span class="mat-label-large notification-menu__processes-placeholder">
			{{"Keine Vorgänge vorhanden" | translate : "label-no-processes"}}
		</span>
		}
	</app-side-menu-content>
</app-side-menu>